const MedicalRecordsHistoryTypeEnum = {
  CLINIC_HISTORY: 'clinic_history',
  MRR_STATE: 'mrr_state',
};

const MedicalRecordsReviewHistoryCreatedByEnum = {
  VET: 'Vet',
  CUSTOMER: 'Customer',
  SYSTEM: 'System',
  OPS_USER: 'Ops User',
};

const MedicalRecordsReviewHistoryActionEnum = {
  CREATED: 'Created',
  UPDATED: 'Updated',
  DELETED: 'Deleted',
};

const PetMrrStateEnum = {
  NEEDS_REVIEW: { id: 'needs_review', name: 'Needs Review' },
  PARTIAL_HISTORY_REVIEWED: {
    id: 'partial_history_review',
    name: 'Partial History Reviewed',
  },
  APPEAL_UNDER_REVIEW: { id: 'appeal_under_review', name: 'Appeal Under Review' },
  FULL_HISTORY_REVIEWED: {
    id: 'full_history_review',
    name: 'Full History Reviewed',
  },
  MR_REVIEW_NOT_NEEDED: { id: 'mr_review_not_needed', name: 'MR Review Not Needed' },
  PREVISIT_MRR_TRIGGERED: {
    id: 'previsit_mrr_triggered',
    name: 'Pre-visit MRR Triggered',
  },
  PREVISIT_MRR_AWAITING_RECORDS: {
    id: 'previsit_mrr_awaiting_records',
    name: 'Pre-visit MRR Awaiting Records',
  },
  PREVISIT_MRR_INFO_UPDATED: {
    id: 'previsit_mrr_info_updated',
    name: 'Pre-visit MRR Info Updated',
  },

  choices() {
    return Object.values(this).filter(value => typeof value === 'object');
  },

  getById(id) {
    return (
      Object.values(this).find(state => state.id === id) || {
        id: 'unknown_or_no_review',
        name: 'Unknown or No Review',
      }
    );
  },
};

export {
  PetMrrStateEnum,
  MedicalRecordsHistoryTypeEnum,
  MedicalRecordsReviewHistoryCreatedByEnum,
  MedicalRecordsReviewHistoryActionEnum,
};
